import { z } from "zod";
import { defineEvent } from "./registry.js";
/**
 * Sadakat olayları (Prompt 17, ADR 0017 §18–27). Yük KİŞİSEL VERİ TAŞIMAZ: yalnızca kimlikler, puan ve tutar (kuruş)
 * dizgeleri; ad / telefon / kart no / plaka YOKTUR. Ayrıntıyı isteyen istemci `loyalty.read` yetkili uçlardan çeker.
 */
const points = z.string().regex(/^-?\d{1,15}$/);
const money = z.string().regex(/^-?\d{1,19}$/);
export const loyaltyPointsEarnedV1 = defineEvent({
    type: "loyalty.points.earned",
    version: 1,
    description: "Kasa satışı puan kazandırdı (işlendi ya da kötüye kullanım şüphesiyle incelemede)",
    realtime: ["tenant"],
    payload: z.object({
        entryId: z.uuid(),
        customerProfileId: z.uuid(),
        companyId: z.uuid(),
        stationId: z.uuid(),
        saleId: z.uuid().nullable(),
        points,
        value: money,
        status: z.enum(["POSTED", "PENDING_REVIEW"]),
    }),
});
export const loyaltyPointsRedeemedV1 = defineEvent({
    type: "loyalty.points.redeemed",
    version: 1,
    description: "Puanla ödeme deftere yazıldı (FIFO parti tüketimi)",
    realtime: ["tenant"],
    payload: z.object({
        entryId: z.uuid(),
        customerProfileId: z.uuid(),
        companyId: z.uuid(),
        stationId: z.uuid().nullable(),
        saleId: z.uuid(),
        points,
        value: money,
    }),
});
export const loyaltyPointsOverdrawnV1 = defineEvent({
    type: "loyalty.points.overdrawn",
    version: 1,
    description: "Puan bakiyesi eksiye düştü (çevrimdışı harcama ya da iade kazanımı geri alırken partiler yetmedi) — satış reddedilmez",
    realtime: ["tenant"],
    payload: z.object({
        entryId: z.uuid(),
        customerProfileId: z.uuid(),
        entryType: z.enum(["REDEEM", "REVERSAL", "ADJUST"]),
        saleId: z.uuid().nullable(),
        shortfall: points,
        balanceAfter: points,
    }),
});
export const loyaltyPointsExpiringV1 = defineEvent({
    type: "loyalty.points.expiring",
    version: 1,
    description: "Puan partisinin süresi yaklaşıyor (parti başına bir kez; bildirim / pazarlama tetikleyicisi)",
    realtime: [],
    payload: z.object({
        lotId: z.uuid(),
        customerProfileId: z.uuid(),
        points,
        expiresAt: z.iso.datetime({ offset: true }),
    }),
});
export const loyaltyPointsExpiredV1 = defineEvent({
    type: "loyalty.points.expired",
    version: 1,
    description: "Süresi dolan puan partileri EXPIRE hareketiyle düşüldü (müşteri başına özet)",
    realtime: ["tenant"],
    payload: z.object({
        customerProfileId: z.uuid(),
        lotCount: z.number().int().positive(),
        points,
        value: money,
    }),
});
export const loyaltyAbuseSuspectedV1 = defineEvent({
    type: "loyalty.abuse_suspected",
    version: 1,
    description: "Kazanım kötüye kullanım kuralını aştı; puan incelemeye düştü (bakiyeye girmedi)",
    realtime: ["station", "tenant"],
    payload: z.object({
        entryId: z.uuid(),
        customerProfileId: z.uuid(),
        stationId: z.uuid(),
        saleId: z.uuid(),
        verdict: z.enum(["TOO_FREQUENT", "DAILY_CAP"]),
        points,
    }),
});
export const loyaltyTierChangedV1 = defineEvent({
    type: "loyalty.tier.changed",
    version: 1,
    description: "Müşterinin sadakat seviyesi değişti (yükselme kazanımda, düşme gece değerlendirmesinde)",
    realtime: ["tenant"],
    payload: z.object({
        customerProfileId: z.uuid(),
        fromTier: z.string().nullable(),
        toTier: z.string().nullable(),
        mode: z.enum(["EARN", "NIGHTLY"]),
        windowPoints: points,
    }),
});
export const loyaltyCouponRedeemedV1 = defineEvent({
    type: "loyalty.coupon.redeemed",
    version: 1,
    description: "Kasada kupon kullanıldı (uyarıyla ya da uyarısız — satış reddedilmez)",
    realtime: ["tenant"],
    payload: z.object({
        couponId: z.uuid(),
        couponCampaignId: z.uuid(),
        saleId: z.uuid(),
        stationId: z.uuid(),
        warning: z.enum(["ALREADY_REDEEMED", "EXPIRED", "NOT_ISSUED", "CUSTOMER_MISMATCH"]).nullable(),
    }),
});
export const loyaltyCouponDoubleRedemptionV1 = defineEvent({
    type: "loyalty.coupon.double_redemption",
    version: 1,
    description: "Kullanım hakkı bitmiş kupon yeniden kullanıldı (çevrimdışı çift kullanım) — alarm",
    realtime: ["station", "tenant"],
    payload: z.object({
        couponId: z.uuid(),
        couponCampaignId: z.uuid(),
        saleId: z.uuid(),
        stationId: z.uuid(),
        usesBefore: z.number().int(),
        maxUses: z.number().int(),
    }),
});
export const loyaltySubscriptionActivatedV1 = defineEvent({
    type: "loyalty.subscription.activated",
    version: 1,
    description: "Abonelik açıldı, yenilendi ya da yeniden başladı",
    realtime: ["tenant"],
    payload: z.object({
        subscriptionId: z.uuid(),
        planId: z.uuid(),
        customerProfileId: z.uuid().nullable(),
        counterpartyId: z.uuid().nullable(),
        action: z.enum(["CREATE", "RENEW", "REACTIVATE", "MANUAL"]),
        periodStart: z.iso.date(),
        periodEnd: z.iso.date(),
        saleId: z.uuid().nullable(),
    }),
});
export const loyaltySubscriptionOverusedV1 = defineEvent({
    type: "loyalty.subscription.overused",
    version: 1,
    description: "Abonelik hakkı aşıldı (kasa çevrimdışıyken ya da dönem dışı kullanım) — satış reddedilmez",
    realtime: ["station", "tenant"],
    payload: z.object({
        subscriptionId: z.uuid(),
        saleId: z.uuid(),
        stationId: z.uuid(),
        lineNo: z.number().int(),
        reason: z.string(),
        quantity: z.string(),
    }),
});
//# sourceMappingURL=loyalty.v1.js.map